export default __webpack_public_path__ + "static/media/880521487373725706.28724305.png";